export default __webpack_public_path__ + "static/media/czlowiek3.72ecb0bd.svg";